document.addEventListener("DOMContentLoaded", function() {
    var reviewBadge = document.querySelector('#review-scroller');
    var reviewsTab = document.querySelector('.station-tabs-tab[data-type="app"]');
    var reviewsTabPanel = document.querySelector('.station-tabs-tabpanel[data-type="app"]');
    var allTabs = document.querySelectorAll('.station-tabs-tab');
    var allTabPanels = document.querySelectorAll('.station-tabs-tabpanel');
    var reviewScroller = document.querySelector('.product-call-outs-wrapper');

    if (reviewBadge && reviewsTab && reviewsTabPanel) {
        reviewBadge.addEventListener('click', function() {
          console.log('clicked')
            
          reviewsTab.scrollIntoView({ behavior: 'smooth' });
            
            // Open the reviews tab
            reviewsTab.classList.add('is-active');
            reviewsTab.setAttribute('aria-selected', 'true');
            reviewsTabPanel.classList.add('is-active');
            reviewsTabPanel.setAttribute('aria-hidden', 'false');
            console.log(reviewsTab);
            console.log(reviewsTabPanel);
            // Close other tabs
            allTabs.forEach(function(tab) {
                if (tab !== reviewsTab) {
                    tab.classList.remove('is-active');
                    tab.setAttribute('aria-selected', 'false');
                }
            });
            allTabPanels.forEach(function(panel) {
                if (panel !== reviewsTabPanel) {
                    panel.classList.remove('is-active');
                    panel.setAttribute('aria-hidden', 'true');
                }
            });
        });
    }
});
